import type { MixpanelVersionT } from '@mathflat/shared/@modules/mixpanel/MixpanelClient'

import type { Academy } from '@/dto/Academy'

export type UserPropertiesSchema = {
  D코드: Academy['academyId']
  학원명: Academy['name']
  요금제: Academy['subscribePlan']
  사용제품: Academy['authority']
  가입상태: Academy['status']
  CRM학원분류값: Academy['customerType']
  이메일: Academy['email']
  등록반수: Academy['lessonClassCount']
  등록학생수: Academy['studentCount']
  무료체험시작일: Academy['freeStartDate']
  무료체험종료일: Academy['freeEndDate']
  정식가입시작일: Academy['payStartDate']
  정식가입종료일: Academy['payEndDate']
  프리미엄체험시작일: Academy['freePremiumStartDate']
  프리미엄체험종료일: Academy['freePremiumEndDate']
  추가과금학생수: Academy['studentLimitCount']
  월기본구독료: Academy['monthlyBaseFee']
  월납입일: Academy['payDate']
  이닛셋팅여부: Academy['initialized']
  총판코드: Academy['sellerCode']
  userPropertiesVersion: MixpanelVersionT
}

export const convertAcademyToUserProperties = ({
  academy,
}: {
  academy: Academy
}): Partial<UserPropertiesSchema> => {
  return {
    D코드: academy.academyId,
    학원명: academy.name,
    요금제: academy.subscribePlan,
    사용제품: academy.authority,
    가입상태: academy.status,
    CRM학원분류값: academy.customerType,
    이메일: academy.email,
    등록반수: academy.lessonClassCount,
    등록학생수: academy.studentCount,
    무료체험시작일: academy.freeStartDate,
    무료체험종료일: academy.freeEndDate,
    정식가입시작일: academy.payStartDate,
    정식가입종료일: academy.payEndDate,
    프리미엄체험시작일: academy.freePremiumStartDate,
    프리미엄체험종료일: academy.freePremiumEndDate,
    추가과금학생수: academy.studentLimitCount,
    월기본구독료: academy.monthlyBaseFee,
    월납입일: academy.payDate,
    이닛셋팅여부: academy.initialized,
    총판코드: academy.sellerCode,
  }
}
